<!--
 * @Author: junfeng.liu
 * @Date: 2018-12-17 09:05:43
 * @LastEditors: junfeng.liu
 * @LastEditTime: 2018-12-17 10:47:12
 * @Description: 分割线
 -->
<template>
    <div class="bp-divider" :class="dClass">
        <span v-if="$slots.default && type === 'horizontal'" class="bp-divider-text">
            <slot></slot>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'horizontal'
        },
        dashed: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {

        }
    },
    computed: {
        dClass () {
            if (this.type === 'vertical') {
                return 'bp-divider-vertical'
            }
            else if (this.$slots.default) {
                if (this.dashed) {
                    return 'bp-divider-with-text bp-divider-with-text-dashed'
                }
                return 'bp-divider-with-text'
            }
            else if (!this.$slots.default && this.type === 'horizontal') {
                if (this.dashed) {
                    return 'bp-divider-horizontal bp-divider-dashed'
                }
                return 'bp-divider-horizontal'
            }
        }
    },
    methods: {

    }
}
</script>

<style lang="less">
.bp-divider{
    position: relative;
    width: 100%;
}
.bp-divider.bp-divider-vertical{
    width: 1px;
    height: .9em;
    top: .06em;
    background: #e8eaec;
    margin: 0 8px;
    vertical-align: middle;
    display: inline-block;
}
.bp-divider.bp-divider-horizontal{
    margin: 20px 0;
    height: 1px;
    background: #e8eaec;
}
.bp-divider.bp-divider-horizontal.bp-divider-dashed{
    background: none;
    border-top: 1px dashed #e8eaec;
}
.bp-divider.bp-divider-with-text{
    text-align: center;
    display: table;
    margin: 12px 0;
    white-space: nowrap;
    .bp-divider-text{
        display: inline-block;
        padding: 0 20px;
        font-size: 16px;
    }
    &::before{
        content: '';
        display: table-cell;
        position: relative;
        width: 50%;
        top: 50%;
        transform: translateY(50%);
        border-top: 1px solid #e8eaec;
    }
    &::after{
        content: '';
        display: table-cell;
        position: relative;
        width: 50%;
        top: 50%;
        transform: translateY(50%);
        border-top: 1px solid #e8eaec;
    }
}
.bp-divider.bp-divider-with-text.bp-divider-with-text-dashed{
    &::before{
        border-top: 1px dashed #e8eaec;
    }
    &::after{
        border-top: 1px dashed #e8eaec;
    }
}
</style>